// components/ExcelExportButton.tsx
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { dashboardPaymentsCard_data } from "../../../data/ApiController.js";
import { categoryMapping } from "./transactionAnalysis.jsx";

const ExcelPaymentExportButton = () => {
    const [transactionData, setTransactionData] = useState([]);

    useEffect(() => {
        const fetchTransactionData = async () => {
            try {
                const response = await dashboardPaymentsCard_data();
                const data = response.data;
                const categoriesSummary = data.categoriesSummary;

                const formattedData = categoriesSummary.map(item => ({
                    category: item.category,
                    name: categoryMapping[item.category] || item.category,
                    totalAmount: parseFloat(item.totalAmount),
                    averageAmount: parseFloat(item.averageAmount),
                    count: parseInt(item.count),
                }));

                setTransactionData(formattedData);
            } catch (error) {
                console.error('Error fetching transaction data:', error);
            }
        };

        fetchTransactionData();
    }, []);

    const exportToExcel = () => {
        // Create a worksheet from the transaction data
        const worksheet = XLSX.utils.json_to_sheet(transactionData);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction Data");

        // Trigger a download
        XLSX.writeFile(workbook, "TransactionDetails.xlsx");
    };

    return (
        <button
            onClick={exportToExcel}
            className="bg-lime-600 text-white px-4 py-2 rounded shadow hover:bg-lime-500"
        >
            Export Transaction Data to Excel
        </button>
    );
};

export default ExcelPaymentExportButton;
